export default __webpack_public_path__ + "static/media/doctor_photo.e1d66414.png";